import Container from '@components/ui/layout/Container'
import { MotionValue } from 'framer-motion'
import React, { FC, useEffect, useRef, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { HowItWorksSingleton } from '__generated__/sanity'
import { SectionContent } from './section-content'
import { SectionImage } from './section-image'
import * as styles from './styles'

type SectionsProps = {
  sections: HowItWorksSingleton['fields']['enhancing']['images']
  scrollY: MotionValue<number>
}

export const Sections: FC<SectionsProps> = ({ sections, scrollY }) => {
  const [start, setStart] = useState<number | null>(null)
  const [windowHeight, setWindowHeight] = useState<number | null>(null)
  const [windowWidth, setWindowWidth] = useState<number | null>(null)
  const containerRef = useRef<HTMLDivElement>()
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  })

  useEffect(() => {
    calculateValues()

    window.addEventListener('resize', calculateValues)

    return () => {
      window.removeEventListener('resize', calculateValues)
    }
  }, [inView])

  return (
    <Container innerRef={inViewRef}>
      <div
        className={styles.sectionContainer}
        ref={containerRef}
        style={{ height: `${sections.length * 100}vh` }}
      >
        <div className={styles.contentContainer}>
          {sections.map((section, key) => {
            if (
              !section.enhancingLayerIcon ||
              !section.enhancingLayerDesktopimage ||
              !section.enhancingLayerMobileimage
            ) {
              return null
            }
            return (
              <SectionContent
                key={section.enhancingLayerDesktopimage.asset._ref}
                title={section.enhancingLayerTitle}
                description={section.enhancingLayerDescription}
                iconSource={section.enhancingLayerIcon.asset}
                scrollY={scrollY}
                start={start}
                multiplier={key}
                windowHeight={windowHeight}
                windowWidth={windowWidth}
                isLast={key + 1 === sections.length}
              />
            )
          })}
        </div>
        <div className={styles.stickyContainer}>
          <div className={styles.imageParent}>
            {sections.map((section, key) => {
              if (
                !section.enhancingLayerIcon ||
                !section.enhancingLayerDesktopimage ||
                !section.enhancingLayerMobileimage
              ) {
                return null
              }
              return (
                <SectionImage
                  key={section.enhancingLayerDesktopimage.asset._ref}
                  imageSourceMobile={section.enhancingLayerMobileimage.asset}
                  imageSourceDesktop={section.enhancingLayerDesktopimage.asset}
                  scrollY={scrollY}
                  start={start}
                  multiplier={key}
                  windowHeight={windowHeight}
                />
              )
            })}
          </div>
        </div>
      </div>
    </Container>
  )

  function calculateValues() {
    if (containerRef && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      setStart(rect.top + scrollTop - window.innerHeight)
      setWindowHeight(window.innerHeight)
      setWindowWidth(window.innerWidth)
    }
  }
}
